import axios from 'axios'
import { toast } from '@/utils/alert'
import { serverUrl } from '@/utils/url'
import store from '@/store'
// import { HTTP } from '@ionic-native/http'



const instance = axios.create({
  baseURL: serverUrl,
  headers: {
  }
})



// 添加请求拦截器
instance.interceptors.request.use(async (config) => {
  store.commit('request/pushLoadings', config.url)

  if (config.url != '/sso/user/login') {
    config.headers.token = store.getters['user/token'] || ''
  }

  return config
},
  error => {
    return Promise.reject(error)
  })

// 添加响应拦截器
instance.interceptors.response.use(
  (res) => {
    const { config } = res
    store.commit('request/popLoadings', config.url)
    if (res.data.code == 500) {
      console.log('WEB error 500', res)
      toast(res.data.msg)
      return Promise.reject(res)
    }
    return res
  },
  async (error) => {
    // store.commit('request/popLoadings', config.url)
    return Promise.reject(error)
  }
)

export default instance
